import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Link, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import DialogDetalharIntegracao from "../DialogDetalharIntegracao";
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { ConfirmProvider } from "material-ui-confirm";

export default function DialogDetalharGrupoIntegracao({
    open,
    handleClose,
    grupoIntegracao,
}: DialogDetalharGrupoIntegracaoProps) {

    const queryClient = useQueryClient();

    const [detalheIntegracao, setDetalheIntegracao] = useState<number>();

    //queries e mutations
    const { mutate } = useMutation({
        mutationKey: ["baixar-arquivo"],
        mutationFn: async (inputs: InputsBaixarArquivo) => await axiosClient.get(`/baixar-arquivo/${inputs.id}`, {
            responseType: 'blob'
        }),
        onError: (e) => {
            console.error(e)
            enqueueSnackbar("Erro ao baixar arquivo de importação", { variant: "error" })
        },
        onSuccess: (response, inputs) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', inputs.nomeArquivo);

            document.body.appendChild(link);
            link.click();

            link.parentNode?.removeChild(link);
        },
    });

    //

    //funções manipuladoras
    const handleBaixarArquivo = (inputs: InputsBaixarArquivo) => {
        mutate(inputs)
    }

    const handleResetGrupoIntegracao = () => {
        setDetalheIntegracao(undefined)
        queryClient.invalidateQueries("pesquisar-integracoes-bancarias")
        handleClose()
    }

    //

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>Detalhe {grupoIntegracao[0].tipo}</DialogTitle>
                <DialogContent>

                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>ID</strong></TableCell>
                                <TableCell><strong>Data importação</strong></TableCell>
                                <TableCell><strong>Data arquivo</strong></TableCell>
                                <TableCell><strong>Importação</strong></TableCell>
                                <TableCell><strong>Usuário</strong></TableCell>
                                <TableCell><strong>Status</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {grupoIntegracao.map((row: any) => {

                                const statusAguardo = row.status === "Aguardando finalização"
                                const statusPendente = row.status === "Finalizado com pendências" || row.status === "Pendente de gravação em caixas e bancos";

                                return (
                                    <TableRow
                                        key={row.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell>
                                            <Link onClick={() => setDetalheIntegracao(row.id)} sx={{ cursor: 'pointer' }}>#{String(row.id).padStart(5, '0')}</Link>
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {moment(row.created_at).format('DD/MM/YYYY HH:mm')}
                                        </TableCell>
                                        <TableCell>
                                            {moment(row.data_referencia_arquivo).format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell>
                                            <Link onClick={() => handleBaixarArquivo({ id: row.arquivo_id, nomeArquivo: row.arquivo })} sx={{ cursor: 'pointer' }}>
                                                {row.arquivo}
                                            </Link>
                                        </TableCell>
                                        <TableCell>{row.usuario || '-'}</TableCell>
                                        <TableCell>
                                            <Chip
                                                color={statusAguardo ? "info" : statusPendente ? "warning" : "success"}
                                                variant="outlined"
                                                label={row.status}
                                                icon={statusAguardo ? <PendingOutlinedIcon /> : statusPendente ? <ErrorOutlineOutlinedIcon /> : <CheckCircleOutlineIcon />}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                            )}
                        </TableBody>
                    </Table>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            {
                detalheIntegracao && detalheIntegracao > 0 &&
                <ConfirmProvider defaultOptions={{
                    title: 'Confirmação',
                    cancellationText: "Cancelar",
                    confirmationText: "Confirmar",
                    confirmationButtonProps: { variant: 'contained', color: 'primary' }
                }}>
                    <DialogDetalharIntegracao
                        id={detalheIntegracao}
                        situacao={grupoIntegracao.find((item: any) => item.id === detalheIntegracao)?.status}
                        open={true}
                        handleClose={() => setDetalheIntegracao(undefined)}
                        handleResetGrupoIntegracao={() => handleResetGrupoIntegracao()}
                    />
                </ConfirmProvider>
            }
        </>
    )
}
interface DialogDetalharGrupoIntegracaoProps {
    open: boolean;
    grupoIntegracao: any;
    handleClose: () => void;
}

interface InputsBaixarArquivo {
    id: number;
    nomeArquivo: string;
}
